import React from 'react'

import { Form } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablasComunesService from 'services/tablasComunes.service'

const BancosSelect = ({ ...props }) => {
  const [bancos, setBancos] = React.useState([])

  React.useEffect(() => {
    TablasComunesService.getAsSelect(TiposTablaComunConstant.BANCOS).then(({ data }) => {
      setBancos(data)
    })
  }, [])

  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar</option>
      {bancos.map((x, k) => (
        <option key={k} value={x._id}>
          {x.nombre}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(BancosSelect)
